export default __webpack_public_path__ + "static/media/game-logo.ce8cc5ed.png";